import { render, staticRenderFns } from "./tableDemo.vue?vue&type=template&id=29c73ebd&"
import script from "./tableDemo.vue?vue&type=script&lang=js&"
export * from "./tableDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports